import { 
  Building2, 
  Paintbrush, 
  Sofa, 
  Armchair, 
  Lightbulb, 
  Wifi,
  LucideIcon
} from "lucide-react";

export interface SubCategory {
  id: string;
  name: string;
}

export interface MainCategory {
  id: string;
  name: string;
  icon: LucideIcon;
  subCategories: SubCategory[];
}

export const componentCategories: MainCategory[] = [
  {
    id: "architectural-systems",
    name: "Architectural Systems",
    icon: Building2,
    subCategories: [
      { id: "profiles-structural", name: "Profiles & Structural Sections" },
      { id: "entrance-doors", name: "Entrance Doors (Interior / Exterior)" },
      { id: "windows-doors", name: "Windows & Door Systems" },
      { id: "elevators", name: "Elevators" },
      { id: "custom-architectural", name: "Custom Architectural Elements" },
    ],
  },
  {
    id: "interior-hard-finishes",
    name: "Interior Hard Finishes",
    icon: Paintbrush,
    subCategories: [
      { id: "flooring", name: "Flooring" },
      { id: "tiles", name: "Tiles" },
      { id: "stone-slabs", name: "Stone & Slabs" },
      { id: "wall-finishes", name: "Wall Finishes" },
      { id: "ceiling-systems", name: "Ceiling Systems & Panels" },
    ],
  },
  {
    id: "interior-soft-finishes",
    name: "Interior Soft Finishes",
    icon: Sofa,
    subCategories: [
      { id: "curtains-drapery", name: "Curtains & Drapery" },
      { id: "rugs", name: "Rugs" },
      { id: "upholstery", name: "Upholstery Materials" },
      { id: "bedding-textiles", name: "Bedding & Textiles" },
      { id: "custom-mattresses", name: "Custom Mattresses" },
    ],
  },
  {
    id: "furniture-custom",
    name: "Furniture & Custom Works",
    icon: Armchair,
    subCategories: [
      { id: "sofas", name: "Sofas" },
      { id: "beds", name: "Beds" },
      { id: "casegoods-storage", name: "Casegoods & Storage" },
      { id: "custom-furniture", name: "Custom Furniture" },
      { id: "whole-house", name: "Whole-house Customization" },
    ],
  },
  {
    id: "lighting",
    name: "Lighting",
    icon: Lightbulb,
    subCategories: [
      { id: "interior-lighting", name: "Interior Lighting" },
      { id: "exterior-lighting", name: "Exterior Lighting" },
      { id: "architectural-lighting", name: "Architectural Lighting" },
      { id: "landscape-lighting", name: "Landscape Lighting" },
    ],
  },
  {
    id: "systems-outdoor",
    name: "Systems & Outdoor",
    icon: Wifi,
    subCategories: [
      { id: "smart-home", name: "Smart Home Systems" },
      { id: "renovation-robots", name: "Renovation & Maintenance Robots" },
      { id: "smart-irrigation", name: "Smart Irrigation Systems" },
      { id: "pool-equipment", name: "Pool Equipment & Systems" },
      { id: "outdoor-tiles", name: "Outdoor Tiles & Surfaces" },
    ],
  },
];

// Helper to get all subcategories flat
export const getAllSubCategories = (): SubCategory[] => {
  return componentCategories.flatMap((cat) => cat.subCategories);
};

// Helper to find main category by subcategory id
export const getMainCategoryBySubId = (subId: string): MainCategory | undefined => {
  return componentCategories.find((cat) =>
    cat.subCategories.some((sub) => sub.id === subId)
  );
};
